import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";
import MiscChargesList from "components/menu/master-files/misc-charges/list";

const MerchandiserInvoicingRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={MiscChargesList}
            />
        </Switch>
    </div>
);

export default connect()(MerchandiserInvoicingRouter);
